import React from 'react';
import PropTypes from 'prop-types';
import { CommonTarget } from './common-targeting';

export const Audience = ({ audiences }) => (
  <CommonTarget label={_TL_('Audience')} data={audiences} pluralText="audiences" singularText="audience" />
);

Audience.propTypes = {
  audiences: PropTypes.arrayOf(PropTypes.shape({})),
};

Audience.defaultProps = {
  audiences: [],
};
